import React from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { FaTimes } from "react-icons/fa";

const NewChannelModal = ({
  showModal,
  closeModal,
  newChannelName,
  setNewChannelName,
  allUsers,
  setSelectedUsers,
  selectedUsers,
  handleNewChannel,
}) => {
  const animatedComponents = makeAnimated();

  return (
    showModal && (
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
        <div className="bg-white p-4 rounded-lg shadow-lg w-1/3">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg">Add New Channel</h3>
            <button onClick={closeModal}>
              <FaTimes />
            </button>
          </div>
          <input
            type="text"
            className="p-2 border border-gray-300 rounded w-full"
            placeholder="Channel Name"
            value={newChannelName}
            onChange={(e) => setNewChannelName(e.target.value)}
          />
          <Select
            components={animatedComponents}
            options={allUsers}
            isMulti
            className="mt-2"
            placeholder="Select users"
            onChange={setSelectedUsers}
            value={selectedUsers}
            formatOptionLabel={({ label, photoURL }) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={photoURL}
                  alt="avatar"
                  style={{
                    width: "20px",
                    height: "20px",
                    marginRight: "10px",
                    borderRadius: "50%",
                  }}
                />
                {label}
              </div>
            )}
          />
          <button
            className="mt-4 bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
            onClick={handleNewChannel}
          >
            Create Channel
          </button>
        </div>
      </div>
    )
  );
};

export default NewChannelModal;
